<template>
  <path pid="0" d="M22 14h-7a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1v-7a1 1 0 00-1-1zm-1 7h-5v-5h5zM22 3h-7a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1V4a1 1 0 00-1-1zm-1 7h-5V5h5zM11 14H4a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1v-7a1 1 0 00-1-1zm-1 7H5v-5h5zM11 3H4a1 1 0 00-1 1v7a1 1 0 001 1h7a1 1 0 001-1V4a1 1 0 00-1-1zm-1 7H5V5h5z"/>
</template>
